module.exports = __webpack_public_path__ + "img/188.eae8faef.jpg";